import React from 'react'
import VerifyEmailIcon from '../assets/images/backgrounds/verify-email.svg'
import { useLanguage } from '../context/LanguageContext'
import { maskEmail } from '../utils/email'

const ChangeEmailPending = () => {
  const { t } = useLanguage()
  const pendingEmail = sessionStorage.getItem('changeEmailPendingEmail') || ''
  const maskedEmail = pendingEmail ? maskEmail(pendingEmail) : ''

  return (
    <div className="flex flex-col items-center max-w-md mx-auto mt-8 px-4">
      {maskedEmail ? (
        <>
          <img
            src={VerifyEmailIcon}
            alt="Verification email sent"
            className="mb-4"
          />

          <h2 className="mb-3 text-sm leading-7 font-bold text-theme-secondary">
            {t('changeEmail.verificationSentTitle')}
          </h2>

          <p className="mb-1 text-center text-xs font-normal text-theme-secondary">
            {t('changeEmail.verificationSentDescription')}
          </p>

          <p className="mb-4 text-center text-xs font-semibold text-theme-primary">
            {maskedEmail}
          </p>

          <p className="text-center text-xs font-normal text-theme-secondary max-w-[22rem]">
            {t('changeEmail.verificationSentFooter')}
          </p>
        </>
      ) : (
        <>
          <img src={VerifyEmailIcon} alt="Session expired" className="mb-4" />

          <h2 className="mb-3 text-sm leading-7 font-bold text-theme-secondary">
            {t('changeEmail.sessionInvalidTitle')}
          </h2>

          <p className="text-center text-xs font-normal text-theme-secondary max-w-[22rem]">
            {t('changeEmail.sessionInvalidBody')}
          </p>
        </>
      )}
    </div>
  )
}

export default ChangeEmailPending
